import type { ColumnEventType } from 'ag-grid-community'

// 1.0 메뉴 트리의 MENU_TYP — FOLD 는 자식을 가진 폴더, PROG 는 화면.
export const MENU_TYPE = { FOLD: 'FOLD', PROG: 'PROG' } as const

// LOGISPRD-16731 — MOMS_AUTH_INFO.BUTTON_LV 에 저장되는 값. 권한관리(MA03) 선택지가 쓴다. 버튼 권한 판정은 BE 가 한다(LOGISPRD-16785).
export const BUTTON_LEVELS = ['LV1', 'LV2', 'LV3', 'LV4'] as const

// LOGISPRD-15456 — 개인 컬럼 배치 저장
export const GRID_COLUMNS_API_PATH = '/api/v1/auth/me/grid-columns'
// GI23~26 이 쓰던 localStorage 키 접두어(`ag-grid-column-state-{key}`)
export const GRID_COLUMNS_LEGACY_STORAGE_PREFIX = 'ag-grid-column-state'
// 너비 조정·이동이 이어질 때 PUT 을 한 번으로 묶는 간격
export const GRID_COLUMNS_SAVE_DEBOUNCE_MS = 500
// 사용자가 헤더를 끌거나 메뉴·더블클릭으로 바꾼 것만 저장한다 — sizeColumnsToFit·columnDefs 갱신(api·gridOptionsChanged 등)은 저장하지 않는다.
// autosizeColumns: 헤더 경계 더블클릭·메뉴 자동 너비는 ag-grid 가 이 source 로 보낸다. 화면 코드가 autoSizeColumns 를 부르면 그것도 저장된다.
export const GRID_COLUMNS_USER_EVENT_SOURCES: ColumnEventType[] = [
  'uiColumnMoved',
  'uiColumnResized',
  'uiColumnDragged',
  'autosizeColumns',
  'columnMenu',
  'contextMenu',
  'toolPanelUi',
  'toolPanelDragAndDrop',
]
export const GRID_COLUMNS_RESET_MENU_LABEL = '기본 배치로 되돌리기'
